import React, { FC } from 'react';
import { Icon, RiskRating } from 'components/atoms';
import { Body, Card, CommentsRow, CTA, ItallicNote, List, Row } from './Profile.styles';
import { ExpandableParagraph } from 'components/molecules';
import DateComponent from 'components/atoms/date/Date';

type ApprovalStatusPanelProps = {
  cta: any;
  approvalComment?: string;
  reviewDate?: string;
  approvalStatus?: string;
  riskRating?: string;
};

export const ApprovalStatusPanel: FC<ApprovalStatusPanelProps> = ({
  cta,
  approvalComment,
  reviewDate,
  approvalStatus,
  riskRating,
}) => {
  return (
    <Card
      style={{
        padding: '0',
      }}
    >
      {cta && (
        <CTA to={cta} aria-label={'Edit'}>
          <Icon icon={'edit-pencil'} aria-hidden size="xxs" />
        </CTA>
      )}

      <Body>
        <List>
          <Row>
            <dt>Current approval status:</dt>
            <dd>{approvalStatus || '-'}</dd>
          </Row>

          <Row>
            <dt>Risk rating:</dt>
            <dd>
              <RiskRating risk={riskRating} />
            </dd>
          </Row>

          <Row>
            <dt>Last review date:</dt>
            <dd>{reviewDate ? <DateComponent dateTime={reviewDate} /> : '-'}</dd>
          </Row>

          <CommentsRow>
            <dt>Comments:</dt>
            {approvalComment ? (
              <ExpandableParagraph text={approvalComment} maximumTextLength={14} />
            ) : (
              <ItallicNote>No comments provided</ItallicNote>
            )}
          </CommentsRow>
        </List>
      </Body>
    </Card>
  );
};
